import React from 'react'
import { WeatherPage } from './pages/WeatherPage'

export default function App() 
{
    return( 
        <div className="app loading">
            <WeatherPage/>
        </div>
    )
}
